import { render } from "./ListeAttestationPage.vue?vue&type=template&id=0d5f54ac&ts=true"
import script from "./ListeAttestationPage.vue?vue&type=script&lang=ts"
export * from "./ListeAttestationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__